import axios from "axios";
import { cleanSession } from "@/services/session";
import storage from "@/components/utils/storage";
import { Message } from "element-ui";
import authService from "@/services/auth.service";

export const httpApi = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 35000,
});

httpApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 500) {
      if (!error.config?.silentError) {
        Message.error("No se pudo conectar con el servidor. ");
      }
      return Promise.reject(error);
    }
    if (error.response.status === 401) {
      cleanSession();
      if (authService.isUsingOAuth2()) {
        window.location.href = `/oauth2/start?rd=${encodeURIComponent(
          window.location.origin + window.location.pathname
        )}`;
      } else {
        window.location = "/#/login";
      }
      return;
    }
    return Promise.reject(error);
  }
);
httpApi.interceptors.request.use(
  async (config) => {
    const token = storage.loadToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    console.error(error);
    return Promise.reject(error);
  }
);
